import React from "react";
import { Link } from "gatsby";

import Layout from "../components/layout";
import { CardBox } from "../components/cardbox";
import Bio from "../components/bio";
import slovakia_flag from "../../static/slovakia_flag.svg";
import styles from "./index.module.scss";
import faker from "faker";

if (typeof window !== "undefined") {
  // @ts-ignore
  window.faker = faker;
}

const About = () => {
  return (
    <Layout>
      <CardBox>
        <Bio showWrittenBy={false} showDescription={false} />
        <div className="flex justify-center">
          <div className="leading-loose w-12/12 sm:w-11/12 md:w-10/12 lg:w-9/12 xl:w-8/12">
            <p className="mb-10">
              Hi there! My name is Martin and this is my personal site made in
              Gatsby. I am from Slovakia{" "}
              <img className={styles.slovakia_flag} src={slovakia_flag} /> - a
              beautiful country located in the center of Europe. Currently, I
              live in a beautiful city called Brno, Czech Republic. Before that,
              I lived in Bratislava - the main capital city of Slovakia where I
              studied software engineering at Slovak Technical University.
            </p>
            <p className="mb-10">
              I am a freelance programmer mainly coding in react.js with
              Typescript. But I have also experience with node.js, deployed on
              AWS EC2 or Lambda.
            </p>
            <p className="mb-10">
              In August 2019 I wrote my very first line for my personal project
              called Lucinda. This project solves project management issues
              along with time tracking. Both combined, giving powerful way tasks
              and personal/team productivity tracking. I am betting on amazing
              user experience and customizable tools which satisfy anyone's
              needs.
            </p>
            <p className="mb-10">
              I often have unnecessary complex thoughts and weird sense of
              humor. Sarcasm is my friend. I love biking, hiking, and hammocking
              at a nice place (I used to hang around near the Danube river in
              Bratislava)
            </p>
            <p className="mb-10">
              Thanks for visiting this site. <Link to="/blog">Start here</Link>
            </p>
          </div>
        </div>
      </CardBox>
    </Layout>
  );
};

export default About;
